

import Vue from '@plugins/vue'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
